import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { PageGuide } from "components/pageGuide";
import { usePageGuideContextOptional } from "components/pageGuide/PageGuideContext";
import { resolvePageGuidePageId } from "components/pageGuide/pageGuidePageRegistry";

/**
 * Mounts a single PageGuide for the current route (or an explicit override).
 */
function PageGuideRouteMount() {
  const location = useLocation();
  const { user, userData, organizationId } = useAuth();
  const ctx = usePageGuideContextOptional();

  if (!user?.uid) return null;

  const fromPath = resolvePageGuidePageId(location.pathname);
  const pageId = ctx?.pageIdOverride || fromPath;
  if (!pageId) return null;

  const facilityId =
    userData?.activeInstitutionId ||
    userData?.institutionId ||
    organizationId ||
    null;

  return <PageGuide pageId={pageId} facilityId={facilityId} />;
}

export default PageGuideRouteMount;
